import * as React from 'react';

interface ISidebarContext {
  isOpen: boolean;
  toggle: () => any;
}

export const SidebarContext = React.createContext<ISidebarContext>({
  isOpen: false,
  toggle: () => {
    // empty function to pass compiler
  }
});

let SidebarContextProvider: React.ComponentType = ({ children }) => {
  const [showSidebar, setShowSidebar] = React.useState(false);
  const toggleSidebar = React.useCallback(() => setShowSidebar(current => !current), [setShowSidebar]);

  const contextValue = React.useMemo<ISidebarContext>(() => ({ isOpen: showSidebar, toggle: toggleSidebar }), [
    showSidebar,
    toggleSidebar
  ]);

  return <SidebarContext.Provider value={contextValue}>{children}</SidebarContext.Provider>;
};

SidebarContextProvider = React.memo(SidebarContextProvider);
export { SidebarContextProvider };
